import axios from 'axios'
import { numericValue } from './realPositions'

const client = axios.create({ baseURL: process.env.VUE_APP_API_URL || '/api', timeout: 30000 })
const object = value => value !== null && typeof value === 'object' && !Array.isArray(value)
const text = value => typeof value === 'string' && value.length > 0
const failure = () => { throw new Error('持仓对照校验失败，请确认前后端已配套部署。') }

export function validatePositionContext(payload) {
  const contract = payload && payload.page_contract
  if (!object(payload) || payload.ok !== true || payload.payload_type !== 'position_context_readonly_page' ||
      payload.contract_version !== 'position_context_readonly_page_v1' || payload.read_only !== true ||
      payload.writes_database !== false || payload.calls_provider !== false || payload.sends_notification !== false ||
      !object(contract) || contract.scope !== 'latest_confirmed_real_and_simulation_context' ||
      contract.stored_timestamp_timezone !== 'UTC' || contract.source_rows_preserved !== true ||
      contract.threshold_source !== 'canonical_default_rules' || contract.risk_value_time !== 'broker_snapshot_time' ||
      !['quantities_merged', 'costs_merged', 'simulation_account_status_is_activation', 'market_analysis_included',
        'direct_write_enabled', 'starts_scheduler', 'sends_notification', 'calls_provider', 'calls_broker_api', 'creates_real_order']
        .every(key => contract[key] === false)) failure()
  const context = payload.position_context, risk = payload.risk_summary
  if (!object(context) || !object(risk) || !text(context.context_id) || !text(context.context_digest) ||
      !['ready', 'degraded'].includes(payload.data_status) || payload.data_status !== context.data_status ||
      risk.context_digest !== context.context_digest || risk.context_id !== context.context_id ||
      risk.ok !== (payload.data_status === 'ready') || risk.read_only !== true ||
      !['writes_first_book', 'writes_simulation_ledger', 'writes_broker_snapshot', 'calls_provider', 'calls_broker_api', 'creates_real_order']
        .every(key => risk[key] === false) ||
      !['normal', 'info', 'warning', 'critical'].includes(risk.risk_status) ||
      !Array.isArray(risk.alerts) || risk.alert_count !== risk.alerts.length || !object(risk.metrics) || !object(risk.thresholds) ||
      !Array.isArray(risk.quality_notes) || !object(context.source_status) || !object(context.counts) ||
      !object(context.same_symbol_policy) || context.same_symbol_policy.quantities_merged !== false ||
      context.same_symbol_policy.costs_merged !== false || context.same_symbol_policy.source_rows_preserved !== true ||
      !object(payload.real_account)) failure()
  if (!risk.quality_notes.every(note => typeof note === 'string') || !object(context.strict_separation) ||
      !['writes_first_book', 'writes_simulation_ledger', 'writes_broker_snapshot', 'creates_real_order', 'calls_broker_api',
        'calls_provider', 'starts_position_context_watch', 'sends_notification'].every(key => context.strict_separation[key] === false)) failure()
  for (const key of ['broker_snapshot', 'simulation_ledger', 'first_book_scope']) {
    if (!object(context.source_status[key]) || !text(context.source_status[key].status)) failure()
  }
  if (context.source_status.broker_snapshot.status === 'ready' && !text(context.source_status.broker_snapshot.snapshot_id)) failure()
  for (const [key, source] of [['real_positions', 'broker_snapshot'], ['simulation_positions', 'simulation_ledger']]) {
    if (!Array.isArray(context[key]) || context.counts[key] !== context[key].length) failure()
    const identities = new Set()
    for (const row of context[key]) {
      if (!object(row) || row.position_source !== source || !text(row.ts_code) ||
          numericValue(row.quantity) === null || numericValue(row.quantity) < 0) failure()
      const id = source === 'broker_snapshot' ? row.snapshot_id + ':' + row.ts_code : row.sim_id
      if (!text(id) || identities.has(id)) failure()
      identities.add(id)
      if (source === 'broker_snapshot' && (row.snapshot_id !== context.source_status.broker_snapshot.snapshot_id ||
          row.simulated !== false || row.position_truth !== true)) failure()
      if (source === 'simulation_ledger' && (row.simulated !== true || row.position_truth !== false || row.not_real_trade !== true)) failure()
    }
  }
  if (context.counts.all_position_rows !== context.real_positions.length + context.simulation_positions.length ||
      (context.source_status.broker_snapshot.status === 'ready' &&
      (payload.real_account.snapshot_id !== context.source_status.broker_snapshot.snapshot_id ||
       payload.real_account.snapshot_as_of !== context.source_status.broker_snapshot.as_of))) failure()
  for (const alert of risk.alerts) {
    if (!object(alert) || !text(alert.alert_id) || !text(alert.title) || !text(alert.message) ||
        !['critical', 'warning', 'info'].includes(alert.severity)) failure()
  }
  return payload
}

// Group for display only: preserve each original row; never sum shares or costs.
export function comparisonRows(context) {
  const byCode = new Map()
  for (const [key, column, source] of [['real_positions', 'real', 'broker_snapshot'], ['simulation_positions', 'simulation', 'simulation_ledger']]) {
    if (context.source_status[source].status !== 'ready') continue
    for (const row of context[key]) {
      if (!byCode.has(row.ts_code)) byCode.set(row.ts_code, { ts_code: row.ts_code, name: row.name, real: [], simulation: [] })
      byCode.get(row.ts_code)[column].push(row)
    }
  }
  return [...byCode.values()].sort((a, b) => a.ts_code.localeCompare(b.ts_code))
}

export const positionContextApi = {
  read: () => client.get('/real-positions/stage5/position-context', {
    params: { _: Date.now() }, headers: { 'Cache-Control': 'no-cache' }
  }).then(response => validatePositionContext(response.data))
}
